import { PLAN_ACTION, RESET_ACTION } from '../staticData';

export function planReducer(state: any, action: any) {
  switch (action.type) {
    case PLAN_ACTION.set:
      return { ...state, ...action.payload };

    case RESET_ACTION:
      return {};

    default:
      throw new Error();
  }
}
